module.exports = __webpack_public_path__ + "media/images/link-logo-ff45852704c19a53419cda8a358ef0cf.svg";